function setupInfiniteScroll() {
  const wrapper = document.getElementById("infinite-scroll-wrapper");
  const productGrid = document.getElementById("product-grid");

  if (!wrapper || !productGrid) return;

  let loading = false;

  const loadMore = async () => {
    if (loading) return;
    const nextUrl = wrapper.dataset.nextUrl;
    if (!nextUrl) return;

    loading = true;

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");

      const newWrapper = html.querySelector("#infinite-scroll-wrapper");
      const newProducts = newWrapper.querySelectorAll("#product-grid > li");

      newProducts.forEach((item) => {
        productGrid.appendChild(item);
      });

      const newNextUrl = newWrapper.dataset.nextUrl;
      if (newNextUrl) {
        wrapper.dataset.nextUrl = newNextUrl;
      } else {
        wrapper.removeAttribute("data-next-url");
      }
    } catch (error) {
      console.error("Infinite scroll error:", error);
    } finally {
      loading = false;
    }
  };

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    if (scrollTop + clientHeight >= scrollHeight - (scrollHeight / 2)) {
      loadMore();
    }
  };

  // Prevent multiple scroll listeners
  window.removeEventListener("scroll", window._infiniteScrollHandler);
  window._infiniteScrollHandler = handleScroll;
  window.addEventListener("scroll", handleScroll);
}

// Run on initial load
document.addEventListener("DOMContentLoaded", setupInfiniteScroll);

const observer = new MutationObserver(() => {
  setupInfiniteScroll(); // Re-run scroll setup when product grid changes
});

const targetNode = document.querySelector('.facets-container');

if (targetNode) {
observer.observe(targetNode, {
childList: true,
subtree: true,
});
}

